import React, { useState, useEffect, useContext } from "react";
import Navbar from "./Navbar";
import { NavbarContext, NavigateContext } from "../App";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import { buildAccountJsonBody, buildProsArray, buildOrgsArray, accountNameLoaded } from "../utils/accountBody";

var baseUrl = "https://cognitunerdev.azurewebsites.net";

var token = localStorage.getItem("token");
var createOrgClient = localStorage.getItem("createOrgClient");
var navigateFromClient = localStorage.getItem("navigateFromClient");
var clientUserId = localStorage.getItem("clientUserId");
var userLanguage = localStorage.getItem("userLanguage");
var userId = localStorage.getItem("userId");
var selectedClientUserId = localStorage.getItem("selectedClientUserId");
var templateMenuNavigate = localStorage.getItem("templateMenuNavigate");

function checkTemplate(type, endDate) {
  var dateNowUtc = new Date().toUTCString();
  var dateNow = new Date(dateNowUtc).valueOf();
  var endDateNow = new Date(endDate).valueOf();

  if (dateNow > endDateNow) {
    return false;
  }

  if (type === "template") {
    return true;
  }

  return false;
}

function checkRecipeType(t, type) {
  if (type !== null) {
    return t("local_" + type);
  }
  else {
    return "Unknown";
  }
}

function fillHiddenSearchBar1(event) {
  var searchBar1 = document.getElementById("MenuSearchbar");
  var searchBar2 = document.getElementById("MenuSearchbar2");

  if (searchBar1 !== null && searchBar1 !== undefined &&
    searchBar2 !== null && searchBar2 !== undefined) {
    searchBar1.value = searchBar2.value;
  }
}

function fillHiddenSearchBar2(event) {
  var searchBar1 = document.getElementById("MenuSearchbar");
  var searchBar2 = document.getElementById("MenuSearchbar2");

  if (searchBar1 !== null && searchBar1 !== undefined &&
    searchBar2 !== null && searchBar2 !== undefined) {
    searchBar2.value = searchBar1.value;
  }
}

function editRecipe(id, type, navigate, setNavigateContext) {
  localStorage.setItem("templateRecipeId", id);
  localStorage.setItem("selectedRecipeType", type);
  setNavigateContext(true);
  navigate("/newrecipe");
  window.location.reload();
}

function returnToMenu() {
  window.location.replace(window.location.origin + "/menu");
}

function navigateToClientSelection(navigate) {
  navigate("/clientselection");
}

function navigateToMenu(navigate) {
  navigate("/menu");
}

function navigateToOrganisation(navigate) {
  navigate("/organisation");
}

function navigateToClientCreation(navigate) {
  navigate("/createoreditclient");
}

function navigateToRecipes(navigate) {
  navigate("/recipes")
}

function navigateToNewRecipe(navigate) {
  navigate("/newrecipe");
  window.location.reload();
}

function navigateToTemplates(navigate) {
  navigate("/templates");
}

function navigateToClient(navigate) {
  navigate("/client");
}

function returnToLogin() {
  window.location.replace(window.location.origin);
}

const Templates = () => {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    if (userLanguage !== null) {
      i18n.changeLanguage(userLanguage);
    }
  }, [i18n]);

  const tokenExpiredOptions = {
    title: 'Title',
    message: 'Message',
    buttons: [
      {
        label: 'Yes',
        onClick: () => alert('Click Yes')
      },
      {
        label: 'No',
        onClick: () => alert('Click No')
      }
    ],
    childrenElement: () => <div />,
    customUI: ({ title, message, onClose }) =>
      <div className='custom-ui'>
        <h1>{t("local_token_expired")}</h1>
        <button className="confirmButton" onClick={removeTokenAndReturnToLogin}>{t("local_return_to_login")}</button>
      </div>,
    closeOnClickOutside: false,
    willUnmount: () => {}
  }

  const wrongUserDataOptions = {
    title: 'Title',
    message: 'Message',
    buttons: [
      {
        label: 'Yes',
        onClick: () => alert('Click Yes')
      },
      {
        label: 'No',
        onClick: () => alert('Click No')
      }
    ],
    childrenElement: () => <div />,
    customUI: ({ title, message, onClose }) =>
      <div className='custom-ui'>
        <h1>{t("local_wrong_user_data")}</h1>
        <button className="confirmButton" onClick={removeTokenAndReturnToLogin}>{t("local_return_to_login")}</button>
      </div>,
    closeOnClickOutside: false,
    willUnmount: () => {}
  }

  if (token === null || token === undefined || !token) {
    const tokenOptions = {
      title: 'Title',
      message: 'Message',
      buttons: [
        {
          label: 'Yes',
          onClick: () => alert('Click Yes')
        },
        {
          label: 'No',
          onClick: () => alert('Click No')
        }
      ],
      childrenElement: () => <div />,
      customUI: ({ title, message, onClose }) =>
        <div className='custom-ui'>
          <h1>{t("local_token_not_found")}</h1>
          <button className="confirmButton" onClick={returnToLogin}>{t("local_return_to_login")}</button>
        </div>,
      closeOnClickOutside: false,
      willUnmount: () => {}
    }

    confirmAlert(tokenOptions);
  }

  async function setTwoStepFalse() {
    if (userId !== undefined && userId !== null && token !== undefined && token !== null) {
      // Skip the write if the account name never loaded — otherwise full_name
      // goes out as the string "null" and overwrites the real name.
      if (!accountNameLoaded(username)) {
        return;
      }

      document.getElementById("overlay").style.display = "block";

      var jsonBody = buildAccountJsonBody({
        user_id: userId,
        twostep: false,
        email: userEmail,
        full_name: username,
        expires: (userExpires === "null" || userExpires === null) ? null : userExpires,
        locale: userLanguage.toUpperCase(),
        role: role,
        active: true,
        settings: JSON.stringify({
          RestrictToRecipes: false,
          Pros: buildProsArray(userId, userSettingsIds),
        }),
        orgs: buildOrgsArray(org, orgs),
      });

      try {
        const response = await fetch(baseUrl + "/api/v1/account/" + userId, {
          method: "POST",
          headers: { "Authorization": "Bearer " + token, "Content-Type": 'application/json' },
          body: jsonBody,
        });

        console.log(response);

        if (response.status === 200) {
        }
        else if (response.status === 500) {
          const twoStepVerifyFailedOptions2 = {
            title: 'Title',
            message: 'Message',
            buttons: [
              {
                label: 'Yes',
                onClick: () => alert('Click Yes')
              },
              {
                label: 'No',
                onClick: () => alert('Click No')
              }
            ],
            childrenElement: () => <div />,
            customUI: ({ title, message, onClose }) =>
              <div className='custom-ui'>
                <h1>{t("local_two_step_verify_failed")}</h1>
                <button className="confirmButton" onClick={onClose}>Ok</button>
              </div>,
            closeOnClickOutside: false,
            willUnmount: () => {}
          }

          confirmAlert(twoStepVerifyFailedOptions2);
        }
        else {
          const data = await response.json();

          if (data.Message !== null && data.Message !== undefined) {
            var errorMessage = data.Message;

            if (data.Message === "Error_EmailExists") {
              errorMessage = t("local_api_result_error_email_exists");
            }
            else if (data.Message === "Error_UserLimitReached") {
              errorMessage = t("local_api_result_error_user_limit_reached");
            }
            else if (data.Message === "Error_UserNameExists") {
              errorMessage = t("local_api_result_error_user_name_exists");
            }
            else if (data.Message === "Error_Internal") {
              errorMessage = t("local_api_result_error_internal");
            }
            else if (data.Message === "Error_ResourceNotFound") {
              errorMessage = t("local_api_result_error_resource_not_found");
            }
            else if (data.Message === "Error_UnauthorizedAccess") {
              errorMessage = t("local_api_result_error_unauthorized_access");
            }
            else if (data.Message === "Error_InvalidBody") {
              errorMessage = t("local_api_result_error_invalid_body");
            }
            else if (data.Message === "Error_ValidationFailed") {
              errorMessage = t("local_api_result_error_validation_failed");
            }
            else if (data.Message === "Error_InvalidRequest") {
              errorMessage = t("local_api_result_error_invalid_request");
            }
            else if (data.Message === "Error_InsufficientPermissions") {
              errorMessage = t("local_api_result_error_insufficient_permissions");
            }
            else if (data.Message === "Error_InvalidEmail") {
              errorMessage = t("local_api_result_error_invalid_email");
            }
            else if (data.Message === "Error_AlreadyExists") {
              errorMessage = t("local_api_result_error_already_exists");
            }
            else if (data.Message === "Unknown") {
              errorMessage = t("local_api_result_unknown");
            }

            if (data.Message === "AuthError_InvalidAccessToken") {
              confirmAlert(tokenExpiredOptions);
            }
            else {
              const userCreationFailedOptions = {
                title: 'Title',
                message: 'Message',
                buttons: [
                  {
                    label: 'Yes',
                    onClick: () => alert('Click Yes')
                  },
                  {
                    label: 'No',
                    onClick: () => alert('Click No')
                  }
                ],
                childrenElement: () => <div />,
                customUI: ({ title, message, onClose }) =>
                  <div className='custom-ui'>
                    <h1>{errorMessage}</h1>
                    <button className="confirmButton" onClick={onClose}>Ok</button>
                  </div>,
                willUnmount: () => {}
              }

              confirmAlert(userCreationFailedOptions);
            }

          }
        }

        document.getElementById("overlay").style.display = "none";

      } catch (err) {
        document.getElementById("overlay").style.display = "none";

        const userCreationFailedOptions2 = {
          title: 'Title',
          message: 'Message',
          buttons: [
            {
              label: 'Yes',
              onClick: () => alert('Click Yes')
            },
            {
              label: 'No',
              onClick: () => alert('Click No')
            }
          ],
          childrenElement: () => <div />,
          customUI: ({ title, message, onClose }) =>
            <div className='custom-ui'>
              <h1>{t("local_user_edit_failed2")} {err}</h1>
              <button className="confirmButton" onClick={onClose}>Ok</button>
            </div>,
          willUnmount: () => {}
        }

        confirmAlert(userCreationFailedOptions2);
      }
    }

  }

  async function removeTokenAndReturnToLogin() {
    await setTwoStepFalse();
    localStorage.clear();
    localStorage.setItem("userLanguage", userLanguage);
    sessionStorage.clear();
    window.location.replace(window.location.origin);
  }

  const { setNavigateContext } = useContext(NavigateContext);

  window.onpopstate=function() {
    setNavigateContext(false);
    window.location.reload();
  }

  localStorage.removeItem("templateRecipeId");
  localStorage.removeItem("gameLinks" + clientUserId);
  localStorage.removeItem("gameLinksnull");
  localStorage.removeItem("selectedRecipeName");
  localStorage.removeItem("selectedRecipeStartDate");
  localStorage.removeItem("selectedRecipeEndDate");
  localStorage.removeItem("selectedRecipeType");

  for (var i = 0; i < localStorage.length; i++){
    if (localStorage.key(i).startsWith("timesPerDaySelect_")) {
      localStorage.removeItem(localStorage.key(i));
    }
  }

  for (var j = 0; j < localStorage.length; j++){
    if (localStorage.key(j).startsWith("selectedGameParameters_")) {
      localStorage.removeItem(localStorage.key(j));
    }
  }

  async function confirmTemplateRemove(recipeId, recipeTitle, recipeNotify, recipeStartDate, recipeData) {
    const confirmTemplateRemoveOptions = {
      title: 'Title',
      message: 'Message',
      buttons: [
        {
          label: 'Yes',
          onClick: () => alert('Click Yes')
        },
        {
          label: 'No',
          onClick: () => alert('Click No')
        }
      ],
      childrenElement: () => <div />,
      customUI: ({ title, message, onClose }) =>
        <div className='custom-ui'>
          <h1>{t("local_confirm_template_remove")}</h1>
          <button className="confirmButton" onClick={() => { removeTemplate(recipeId, recipeTitle, recipeNotify, recipeStartDate, recipeData); onClose();}}>{t("local_remove_template")}</button>
          <button className="closeButton" onClick={onClose}>{t("local_cancel")}</button>
        </div>,
      willUnmount: () => {}
    }

    confirmAlert(confirmTemplateRemoveOptions);
  }

  async function removeTemplate(recipeId, recipeTitle, recipeNotify, recipeStartDate, recipeData) {
    document.getElementById("overlay").style.display = "block";

    var deleteDate = new Date();

    var deleteYear = deleteDate.getUTCFullYear();
    var deleteMonth = deleteDate.getUTCMonth() + 1;
    var deleteDay = deleteDate.getUTCDate();
    var deleteHours = deleteDate.getUTCHours();
    var deleteMinutes = deleteDate.getUTCMinutes();
    var deleteSeconds = deleteDate.getUTCSeconds();

    if (deleteMonth >= 1 && deleteMonth <= 9) {
      deleteMonth = "0" + deleteMonth;
    }

    if (deleteDay >= 1 && deleteDay <= 9) {
      deleteDay = "0" + deleteDay;
    }

    if (deleteHours >= 0 && deleteHours <= 9) {
      deleteHours = "0" + deleteHours;
    }

    if (deleteMinutes >= 0 && deleteMinutes <= 9) {
      deleteMinutes = "0" + deleteMinutes;
    }

    if (deleteSeconds >= 0 && deleteSeconds <= 9) {
      deleteSeconds = "0" + deleteSeconds;
    }

    var endDate = deleteYear + "-" + deleteMonth + "-" + deleteDay + "T" + deleteHours + ":" + deleteMinutes + ":" + deleteSeconds + "Z";

    var recipeJson = {
      "id": recipeId,
      "title": recipeTitle,
      "user_id": userId,
      "sender_id": userId,
      "notify_by_email": recipeNotify,
      "start_date": recipeStartDate,
      "end_date": endDate,
      "data": recipeData
    }

    console.log(recipeJson);

    var fetchUrl = baseUrl + "/api/v1/recipe/" + userId + "/" + recipeId;

    try {
      const response = await fetch(fetchUrl,
      {
        method: "POST",
        headers: { "Authorization": "Bearer " + token,
        "Auth-ForceAdminClientAccess": "1" },
        body: JSON.stringify(recipeJson),
      });

      console.log(response);

      document.getElementById("overlay").style.display = "none";

      if (response.status === 200) {
        setTimeout( function() {
          window.location.reload();
        }, 300);
      }
      else {
        const recipeSaveFailedOptions = {
          title: 'Title',
          message: 'Message',
          buttons: [
            {
              label: 'Yes',
              onClick: () => alert('Click Yes')
            },
            {
              label: 'No',
              onClick: () => alert('Click No')
            }
          ],
          childrenElement: () => <div />,
          customUI: ({ title, message, onClose }) =>
            <div className='custom-ui'>
              <h1>{t("local_failed_to_remove_template")}</h1>
              <button className="confirmButton" onClick={onClose}>Ok</button>
            </div>,
          willUnmount: () => {}
        }

        confirmAlert(recipeSaveFailedOptions);
      }

    } catch (err) {
      document.getElementById("overlay").style.display = "none";

      const recipeCancelFailedOptions2 = {
        title: 'Title',
        message: 'Message',
        buttons: [
          {
            label: 'Yes',
            onClick: () => alert('Click Yes')
          },
          {
            label: 'No',
            onClick: () => alert('Click No')
          }
        ],
        childrenElement: () => <div />,
        customUI: ({ title, message, onClose }) =>
          <div className='custom-ui'>
            <h1>{t("local_failed_to_remove_template")} {err}</h1>
            <button className="confirmButton" onClick={onClose}>Ok</button>
          </div>,
        willUnmount: () => {}
      }

      confirmAlert(recipeCancelFailedOptions2);
    }
  }

  function searchTemplates(event) {
    var clientElements = document.getElementsByClassName("TemplateRow");
    var setFirstClient = false;

    for (let i = 0; i < clientElements.length; i++) {

      if (event.target.value.trim().length < 2 && clientElements[i].getAttribute("data-hidden") === "true") {
        clientElements[i].setAttribute("style", "display:block !important");
        clientElements[i].setAttribute("data-hidden", "false !important");
      }

      if (event.target.value.trim() !== "" && ( clientElements[i].getAttribute("data-template-name").toLowerCase().includes(event.target.value.trim().toLowerCase()) )) {
        clientElements[i].setAttribute("style", "color:blue !important");
        clientElements[i].setAttribute("data-hidden", "false !important");
        if (setFirstClient === false) {
          setFirstClient = true;
        }
      }
      else if (event.target.value.trim().length >= 2) {
        clientElements[i].setAttribute("style", "display:none !important");
        clientElements[i].setAttribute("data-hidden", "true !important");
      }
      else {
        clientElements[i].setAttribute("style", "color:black !important");
      }
    }
  }

  const [recipes, setRecipes] = useState([]);

  const fetchRecipeData = async () => {

    try {

      const response = await fetch(baseUrl + "/api/v1/recipe/" + userId,
      {
        headers: { "Authorization": "Bearer " + token,
        "Auth-ForceAdminClientAccess": "1" },
      });

      console.log(response);

      if (response.status === 200) {
        const data = await response.json();

        setRecipes(data.recipes);
      }
      else if (response.status === 401) {
        const recipeFetchFailedOptions = {
          title: 'Title',
          message: 'Message',
          buttons: [
            {
              label: 'Yes',
              onClick: () => alert('Click Yes')
            },
            {
              label: 'No',
              onClick: () => alert('Click No')
            }
          ],
          childrenElement: () => <div />,
          customUI: ({ title, message, onClose }) =>
            <div className='custom-ui'>
              <h1>{t("local_no_access_to_recipes")}</h1>
              <button className="confirmButton" onClick={returnToMenu}>{t("local_return_to_menu")}</button>
            </div>,
          willUnmount: () => {}
        }

        confirmAlert(recipeFetchFailedOptions);
      }

    } catch (err) {

      const recipeFetchFailedOptions2 = {
        title: 'Title',
        message: 'Message',
        buttons: [
          {
            label: 'Yes',
            onClick: () => alert('Click Yes')
          },
          {
            label: 'No',
            onClick: () => alert('Click No')
          }
        ],
        childrenElement: () => <div />,
        customUI: ({ title, message, onClose }) =>
          <div className='custom-ui'>
            <h1>{t("local_failed_to_fetch_recipe_data")} {err}</h1>
            <button className="confirmButton" onClick={onClose}>Ok</button>
          </div>,
        willUnmount: () => {}
      }

      confirmAlert(recipeFetchFailedOptions2);
    }
  }

  const [role, setRole] = useState(null);
  const [userEmail, setUserEmail] = useState(null);
  const [username, setUsername] = useState(null);
  const [userExpires, setUserExpires] = useState(null);
  const [org, setOrg] = useState(null);
  const [orgs, setOrgs] = useState(null);
  const [userSettingsIds, setUserSettingsIds] = useState(null);

  const checkUserData = async () => {
    try {
      const response = await fetch(baseUrl + "/api/v1/account/" + userId,
      {
        headers: { "Authorization": "Bearer " + token },
      });

      console.log(response);

      if (response.status === 403) {
        confirmAlert(tokenExpiredOptions);
      }
      else if (response.status === 200) {
        const data = await response.json();

        if (data.twostep !== true && ( data.secret !== null && data.secret !== "none" )) {
          localStorage.clear();
          localStorage.setItem("userLanguage", userLanguage);
          sessionStorage.clear();
          window.location.replace(window.location.origin);
          return;
        }

        setRole(data.role);
        setUserEmail(data.email);
        setUsername(data.full_name);
        setUserExpires(data.expires);
        setOrg(data.orgs[0]);
        setOrgs(data.orgs.toString());

        var settings = data.settings;

        if (settings !== null && settings.substring(settings.indexOf("[") + 1, settings.indexOf("[") + 2) === '"') {
          setUserSettingsIds(settings.substring(settings.indexOf("[") + 1, settings.indexOf("]")).replaceAll('"', ""));
        }
      }
      else {
        confirmAlert(wrongUserDataOptions);
      }

    } catch (err) {

      const accountFetchFailedOptions = {
        title: 'Title',
        message: 'Message',
        buttons: [
          {
            label: 'Yes',
            onClick: () => alert('Click Yes')
          },
          {
            label: 'No',
            onClick: () => alert('Click No')
          }
        ],
        childrenElement: () => <div />,
        customUI: ({ title, message, onClose }) =>
          <div className='custom-ui'>
            <h1>{t("local_failed_to_fetch_account_data")} {err}</h1>
            <button className="confirmButton" onClick={onClose}>Ok</button>
          </div>,
        willUnmount: () => {}
      }

      confirmAlert(accountFetchFailedOptions);
    }
  }

  const fetchData = async () => {
    document.getElementById("overlay").style.display = "block";
    await checkUserData();
    await fetchRecipeData();
    document.getElementById("overlay").style.display = "none";
  }

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const navigate = useNavigate();

  const navbarContext = useContext(NavbarContext);
  if (selectedClientUserId === null) {
    navbarContext.setNavbarStyle(1);
  }
  else {
    navbarContext.setNavbarStyle(2);
  }

  return (
    <div className="Templates-container">
      {<Navbar />}
      <div className="CrumbPathDiv">

        { templateMenuNavigate === "true" ? (
          <React.Fragment>
            <button className="CrumbPath-link btn btn-link btn-link-nopad" onClick={() => navigateToMenu(navigate)}>
              {t("local_button_ingame_menu")}
            </button>
            <span> – </span>
            <button className="CrumbPath-link btn btn-link btn-link-nopad" onClick={() => navigateToTemplates(navigate)}>
              {t("local_templates")}
            </button>
          </React.Fragment>
        ): (
          <React.Fragment>
            <button className="CrumbPath-link btn btn-link btn-link-nopad" onClick={() => navigateToMenu(navigate)}>
              {t("local_button_ingame_menu")}
            </button>
            <span> – </span>
            { createOrgClient === "true" && (
              <React.Fragment>
                <button className="CrumbPath-link btn btn-link btn-link-nopad" onClick={() => navigateToOrganisation(navigate)}>
                  {t("local_organisation")}
                </button>
                <span> – </span>
              </React.Fragment>
            )}
            <button className="CrumbPath-link btn btn-link btn-link-nopad" onClick={() => navigateToClientSelection(navigate)}>
              {t("local_clients_list")}
            </button>
            <span> – </span>
            { navigateFromClient !== null && (
              <React.Fragment>
                <button className="CrumbPath-link btn btn-link btn-link-nopad" onClick={() => navigateToClient(navigate)}>
                  {t("local_client")}
                </button>
                <span> – </span>
              </React.Fragment>
            )}
            <button className="CrumbPath-link btn btn-link btn-link-nopad" onClick={() => navigateToClientCreation(navigate)}>
              {t("local_create_or_edit_client")}
            </button>
            <span> – </span>
            <button className="CrumbPath-link btn btn-link btn-link-nopad" onClick={() => navigateToRecipes(navigate)}>
              {t("local_recipes")}
            </button>
            <span> – </span>
            <button className="CrumbPath-link btn btn-link btn-link-nopad" onClick={() => navigateToNewRecipe(navigate)}>
              {t("local_create_or_edit_recipe")}
            </button>
            <span> – </span>
            <button className="CrumbPath-link btn btn-link btn-link-nopad" onClick={() => navigateToTemplates(navigate)}>
              {t("local_templates")}
            </button>
          </React.Fragment>
        )}
      </div>

      <div className="Menu-container">
        <div className="Menu-left">
          <input type="text" id="MenuSearchbar" onChange={(event) => { searchTemplates(event); fillHiddenSearchBar2(event);}} /><br />
          <strong>{t("local_templates")}</strong>
          <span>
            <button className="CreateClient3 btn btn-link btn-link-nopad" onClick={() => navigateToTemplates(navigate)}>
              {t("local_create_new")}
            </button>
          </span>
          <p className="Templates-Menu-left-footer"p>{t("local_templates_footer")}</p>
        </div>
        <div className="Menu-right">
          <div className="Templates-Menu-right">
            { recipes.length > 0 && (
              <table className="Menu-right-bottom-table-lower">
                <tr>
                  {/*<td className="rd-row1-header1">{t("local_start_date")}</td>
                  <td className="rd-row2-header2">{t("local_end_date")}</td>*/}
                  <td className="rd-row3-header3">{t("local_interest")}</td>
                  <td className="rd-row4-header4">{t("local_recipe_name")}</td>
                  <td className="rd-row5-header5">{t("local_status")}</td>
                  {/*<td className="rd-row6-header6">{t("local_ct_score")}</td>*/}
                </tr>
                { recipes.map(recipe => (
                  <React.Fragment key={recipe.id}>
                    { checkTemplate(recipe.type, recipe.end_date) === true && (
                      <tr className="TemplateRow" data-template-name={recipe.title}>
                        <td className="rd-row3-item1" >Unknown</td>
                        <td className="rd-row4-item1">
                          {recipe.title}
                        </td>
                        <td className="rd-row5-item1">
                          {checkRecipeType(t, recipe.type)}
                        </td>
                        {/*<th className="rd-row6-item1">Unknown</th>*/}
                        <td>
                          { selectedClientUserId !== null ? (
                            <button className="recipeEditLink btn btn-link btn-link-nopad" onClick={() => editRecipe(recipe.id, recipe.type, navigate, setNavigateContext)}>
                              {t("local_use")}
                            </button>
                          ) : (
                            <button className="recipeEditLink btn btn-link btn-link-nopad" onClick={() => editRecipe(recipe.id, recipe.type, navigate, setNavigateContext)}>
                              {t("local_edit")}
                            </button>
                          )}
                        </td>
                        <td>
                          <button className="recipeEditLink btn btn-link btn-link-nopad" onClick={() => confirmTemplateRemove(recipe.id, recipe.title, recipe.notify_by_email, recipe.start_date, recipe.data)}>
                            {t("local_delete")}
                          </button>
                        </td>
                    </tr>
                    )}
                  </React.Fragment>
                ))}
              </table>
            )}
            { selectedClientUserId === null && (
              <table>
                <tr>
                  <td className="ed-row1-item1 reciperow">
                    <a className="Menu-right-top-createoreditrecipe" href="/newrecipe">{t("local_new_template")}</a>
                  </td>
                </tr>
              </table>
            )}

            <input type="text" id="MenuSearchbar2" onChange={(event) => { searchTemplates(event); fillHiddenSearchBar1(event);}} /><br />
          </div>
        </div>
      </div>

      <div id="overlay">
        <div className="Loading-icon-div">
          <img src={require("../images/loading-icon.png")} className="Loading-icon" alt = "Loading..." border = "0"/>
        </div>
      </div>

    </div>
  )
}

export default Templates;
